
import { useNavigate } from 'react-router-dom';

export default function BlogFooter() {
  const navigate = useNavigate();

  return (
    <footer className="bg-stone-800 text-white py-12">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 flex flex-col md:flex-row items-center justify-between gap-6">
        <div>
          <span
            className="text-xl font-bold"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            IBX Brasil
          </span>
          <p className="text-xs text-gray-400 mt-1">
            Gestão de Riscos e Contratação Profissional de Seguros
          </p>
        </div>
        <div className="flex flex-wrap gap-6 text-sm text-gray-400">
          <button onClick={() => navigate('/')} className="hover:text-orange-400 transition-colors cursor-pointer whitespace-nowrap">
            Início
          </button>
          <button onClick={() => navigate('/#servicos')} className="hover:text-orange-400 transition-colors cursor-pointer whitespace-nowrap">
            Serviços
          </button>
          <button onClick={() => navigate('/blog')} className="hover:text-orange-400 transition-colors cursor-pointer whitespace-nowrap text-orange-400">
            Blog
          </button>
          <button onClick={() => navigate('/#contato')} className="hover:text-orange-400 transition-colors cursor-pointer whitespace-nowrap">
            Contato
          </button>
        </div>
        <p className="text-xs text-gray-500">© 2025 IBX Brasil. Todos os direitos reservados.</p>
      </div>
    </footer>
  );
}
